<template>
  <section id="feedback" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-sm feedback-text">
          <h1 class="text-lg">Есть вопросы?</h1>
          <p class="text-sm">Задайте их нашим специалистам</p>
        </div>
        <div class="col-sm align-self-center fb-button">
          <button class="btn btn-feedback btn-outline" @click="$modal.show('feedback');">Задать вопрос</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Feedback"
};
</script>

<style scoped lang="scss">
$bg-color: #f2f7ff;

h1,
p {
  color: $head-color;
}

.container-fluid {
  background-color: $bg-color;
  padding: 40px 0;
}

.fb-button {
  text-align: right;

  @include media-breakpoint-down(sm) {
    text-align: center;
  }
}

.feedback-text {
  @include media-breakpoint-down(sm) {
    margin-left: 10px;
    margin-bottom: 30px;
  }
}

@media (min-width: 320px) and (max-width: 374px) {
  .feedback-text {
    margin-left: 0;
  }
}
</style>
